"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var MicrosoftLogo = function MicrosoftLogo() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "Microsoft-logo_svg",
    x: 0,
    y: 0,
    width: "1em",
    height: "1em",
    style: {
      display: 'block'
    },
    viewBox: "0 0 72 72",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#F25022",
    width: "34.2",
    height: "34.2"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "37.8",
    fill: "#7FBA00",
    width: "34.2",
    height: "34.2"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    y: "37.8",
    fill: "#00A4EF",
    width: "34.2",
    height: "34.2"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "37.8",
    y: "37.8",
    fill: "#FFB900",
    width: "34.2",
    height: "34.2"
  })));
};
var _default = MicrosoftLogo;
exports.default = _default;